// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/animate.css/animate.css
// module id = 960
// module chunks = 1